import { CONTACT_US, NEWS_CATEGORIES, NEWS_POST, WHATSAPP_UPDATE } from "../../config/urls";
import { NewsServices, PostsResponse } from "../../utils/interfaces";
import { apiGet, apiPost } from "../../utils/utils";

export function contactUs(data: object, headers?: object) {
  return new Promise((resolve, reject) => {
    apiPost(CONTACT_US, data, headers)
      .then(async (res) => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });
}


export function whatsappUpdate(data: object, headers?: object){
  return new Promise((resolve, reject) => {
    apiPost(WHATSAPP_UPDATE, data, headers)
      .then(async (res) => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function getNewsCategories(data?: object, headers?: object): Promise<NewsServices[]>{
  return new Promise((resolve, reject) => {
    apiGet(NEWS_CATEGORIES, data, headers)
      .then(async (res) => {
        resolve(res?.data);
      })
      .catch(error => {
        reject(error);
      });
  });
}

export function getNewsPost(url:string='',data?: object, headers?: object): Promise<PostsResponse>{
  return new Promise((resolve, reject) => {
    apiGet(NEWS_POST+url, data, headers)
      .then(async (res) => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });
}